import { createSelector } from 'reselect';

import { NONE } from 'constants/Global';
import { getById } from 'modules/questionModels/selectors';
import { getSelectedDealer } from 'selectors/dealerSelectors';
import { uniq } from 'utils/ObjectUtils';

import { getProps, getRoot } from 'utils/selectors';

import { getSelectedGroup } from '.';

const getConfig = createSelector(getSelectedGroup, group => group?.config?.selfService ?? {});

export const getSelectedQuestionFormModelsConfig = createSelector(
  getConfig,
  ({ selectedQuestionFormModels = {} }) => selectedQuestionFormModels
);

const getQuestionFormModelIdByModuleAndBrandId = createSelector(
  getSelectedQuestionFormModelsConfig,
  getProps,
  (questionFormModels, { brandId, module }) => questionFormModels[module]?.[brandId]
);

export const getQuestionFormModelByModuleAndBrandId = createSelector(
  getRoot,
  getQuestionFormModelIdByModuleAndBrandId,
  (root, questionFormModelId) => getById(root, questionFormModelId)
);

const getGroupAssignedQuestionFormModelUniqIds = createSelector(
  getSelectedQuestionFormModelsConfig,
  selectedQuestionFormModels =>
    Object.values(selectedQuestionFormModels ?? {}).flatMap(selected => Object.values(selected))
);

const getSelectedQuestionFormModels = createSelector(
  getSelectedDealer,
  dealer => dealer?.config?.selfService?.questionForm?.selectedQuestionFormModels
);

const getDealerAssignedQuestionFormModelUniqIds = createSelector(
  getSelectedQuestionFormModels,
  (selectedQuestionFormModels = {}) =>
    uniq(Object.values(selectedQuestionFormModels).flatMap(question => Object.values(question)))
);

const getBreakdownQuestionFormModelId = createSelector(
  getSelectedDealer,
  dealer => {
    const driver = dealer?.config?.selfService?.breakdown?.driverSelectedQuestionFormModels;
    const nonDriver = dealer?.config?.selfService?.breakdown?.nonDriverSelectedQuestionFormModels;

    return [...Object.values(driver ?? {}), ...Object.values(nonDriver ?? {})];
  }
);

export const getDealerAndGroupAssignedQuestionFormModelIds = createSelector(
  getDealerAssignedQuestionFormModelUniqIds,
  getGroupAssignedQuestionFormModelUniqIds,
  getBreakdownQuestionFormModelId,
  (dealerAssignedQuestionIds = [], groupAssignedQuestionIds = [], breakdownQuestionModel = []) =>
    uniq(
      [
        ...dealerAssignedQuestionIds,
        ...(Array.isArray(groupAssignedQuestionIds) ? groupAssignedQuestionIds : [groupAssignedQuestionIds]),
        ...(Array.isArray(breakdownQuestionModel) ? breakdownQuestionModel : [breakdownQuestionModel]),
      ].filter(id => id !== NONE)
    )
);
